document.addEventListener("DOMContentLoaded", () => {
  const alertElement = document.getElementById('alertMessage');
  if (alertElement) {
    fetch('/_data/maintenance.json')
      .then(response => response.json())
      .then(data => {
        if (data && typeof data === 'object' && data.message) {
          document.getElementById('alertMessage').classList.remove('d-none');
          document.getElementById('message').innerHTML = data.message;
        }
      })
      .catch(error => console.error('Error fetching maintenance data:', error));
  }
});